import { Row, Col } from 'antd';
import BarChart from './BarChart';
import Header from './Header';
import CountsTable from './CountsTable';
import FilterSearch from './FilterSearch';
import { VastTrackerWrapper } from './VastTrackerWrapper';
import React, { useEffect } from 'react';
import { connect } from 'dva';
import { hasTabPermission } from './constants';

const VastTracker = ({ dispatch, permissions, countTypeSelected }) => {
  useEffect(() => {
    // loading partner groups during mounting
    dispatch({ type: 'vastTracker/loadPartnerGroups' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const canViewTab = permissions && countTypeSelected && hasTabPermission(permissions, countTypeSelected);

  return (
    <VastTrackerWrapper>
      <Header />
      <br />
      {canViewTab && (
        <>
          <Row>
            <Col span={17}>
              <BarChart />
            </Col>
            <Col span={6} offset={1}>
              <FilterSearch />
            </Col>
          </Row>
          <br />
          <br />
          <CountsTable />
        </>
      )}
    </VastTrackerWrapper>
  );
};

function mapStateToProps({ app, vastTracker }) {
  return {
    permissions: app.currentUser.permissions,
    countTypeSelected: vastTracker.countTypeSelected,
  };
}

export default connect(mapStateToProps)(VastTracker);
